import { useAuthStore, useSignalrStore } from '../../../store';

import { createSignalRContext } from 'react-signalr/signalr';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useQueryClient } from '@tanstack/react-query';

const SignalRContext = createSignalRContext();

const Signalr = ({ children }) => {
    const authToken = useAuthStore((state) => state.authToken);
    const setUserProfile = useAuthStore((state) => state.setUserProfile);

    const setStatus = useSignalrStore((state) => state.setStatus);
    const setConnectionId = useSignalrStore((state) => state.setConnectionId);

    const entityUpdater = useEntityQueryUpdate();

    const actionHandlers = {
        CAMPAIGN_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['campaigns'], ['campaign', newEntity.id]],
                newEntity,
                false
            );
        },
        SHORT_LINK_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['short_links'], ['short_link', newEntity.id]],
                newEntity,
                false
            );
        },
        SIMCARD_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['simcards'], ['simcard', newEntity.id]],
                newEntity,
                false
            );
        },
        AGENT_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['agents'], ['agent', newEntity.id]],
                newEntity,
                false
            );
        },
        MESSAGE_GROUP_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['message_groups'], ['message_group', newEntity.id]],
                newEntity,
                false
            );
        },
        LINK_GROUP_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['link_groups'], ['link_group', newEntity.id]],
                newEntity,
                false
            );
        },
        MEDIA_GROUP_UPDATE: (action) => {
            const newEntity = action.payload;
            entityUpdater(
                [['media_groups'], ['media_group', newEntity.id]],
                newEntity,
                false
            );
        },
        PROFILE_UPDATE: (action) => {
            setUserProfile(action.payload);
        },
        AUTH_SUCCESS: (action) => {
            setConnectionId(action.payload.connectionId);
        },
    };

    SignalRContext.useSignalREffect('OnEvent', (action) => {
        if (import.meta.env.DEV) {
            console.log(action);
        }
        const handler = actionHandlers[action.type];
        if (handler) handler(action);
    });

    const setConnectionStatus = (connection) => {
        setStatus(connection.state);
    };

    return (
        <SignalRContext.Provider
            url={'/ws/app'}
            connectEnabled={authToken != null}
            accessTokenFactory={() => authToken}
            dependencies={[authToken]}
            onOpen={setConnectionStatus}
            onReconnect={setConnectionStatus}
            onClosed={setConnectionStatus}>
            {children}
        </SignalRContext.Provider>
    );
};
export default Signalr;
